import {
  FormControl,
  FormControlProps,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
  SelectProps,
} from "@mui/material"
import React from "react"
import { Controller, FieldValues, UseControllerProps } from "react-hook-form"

type Option = {
  value: string
  label: string
}

export interface ControlledSelectProps<FieldValueProps extends FieldValues>
  extends UseControllerProps<FieldValueProps> {
  label?: string
  options: Array<Option>
  FormControlProps?: FormControlProps
  SelectProps?: SelectProps
}

function ControlledDropdownSelect<FieldValueProps extends FieldValues>({
  control,
  name,
  label,
  options,

  FormControlProps = {},
  SelectProps,
  ...props
}: ControlledSelectProps<FieldValueProps>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({
        fieldState: { error },
        field: { onChange: onChange, ref, value },
      }) => (
        <FormControl {...FormControlProps} {...props} error={Boolean(error)}>
          <InputLabel id={name}>{label}</InputLabel>
          <Select
            labelId={label}
            id={name}
            label={label}
            // control={control}

            inputRef={ref}
            value={value}
            {...props}
            {...SelectProps}
            onChange={(e) => {
              onChange(e.target.value)
              SelectProps?.onChange?.(e, null)
            }}
          >
            {options.map((option) => {
              return (
                <MenuItem key={option.value.toString()} value={option.value}>
                  {option.label}
                </MenuItem>
              )
            })}
          </Select>
          {error?.message && (
            <FormHelperText color="error">{error.message}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  )
}

export default ControlledDropdownSelect
